import * as React from "react";
import {connect} from "react-redux";
import MyStylesComponent from "../components/MyStylesComponent";
import {myStylesSelector} from "../selectors";
import {stylesSelector} from "../../_data/selectors";
import {fetchStylesByUser} from "../middlewares";
import Meta from "../../_data/models/Meta";
import {createOrderedMapfromIDs} from "../../_helpers/utils";

const mapStateToProps = (state, ownProps) => {     
    const styles = createOrderedMapfromIDs(myStylesSelector(state).ids, stylesSelector(state));    
    return {
        items: styles,
        loading: myStylesSelector(state).loading,
        meta: myStylesSelector(state).meta,
        errors: myStylesSelector(state).errors,
        scrollPosition:myStylesSelector(state).scrollPosition
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch: dispatch,
        loadMore: (meta: Meta) => {                        
            if (meta && meta.hasNext()) {
                dispatch(fetchStylesByUser(meta.cursor, meta.nextPage));
            }
        }
    }
};

const MyStylesContainer = connect(mapStateToProps, mapDispatchToProps)(MyStylesComponent);
export default MyStylesContainer;


// WEBPACK FOOTER //
// ./app/client/style/containers/MyStylesContainer.tsx